import { Component } from '@angular/core';
import { DialogRef } from '@fundamental-ngx/core/dialog';
import { NavigationService } from '../../../service/services/misc/navigation/navigation.service';
import {AppConfigService} from "../../../service/services/misc/app-config/app-config.service";

@Component({
    selector: 'app-session-expiry',
    templateUrl: './session-expiry.component.html',
    styleUrls: ['./session-expiry.component.scss'],
    standalone: false
})
export class SessionExpiryComponent {
    constructor(public dialogRef: DialogRef, private _navigationService: NavigationService, private _appConfigService: AppConfigService) {}

    reload() {
        let userInfo = this._appConfigService.getUserInfoModel();
        const oidc = userInfo?.oidc || "sap.ids";
        this._navigationService.navigateToLogin(decodeURIComponent(window.location.href), oidc);
    }
}
